import { theme, styled, utils } from 'ui/theme';

export const Close = styled('div')`
  position: absolute;
  top: ${theme.space[4]};
  right: ${theme.space[4]};

  > button[data-size='large'] {
    height: ${theme.space[8]};
    width: ${theme.space[8]};
    padding: var(--sizes-0);

    ${utils.media.max('m')`
      height: ${theme.space[6]};
      width: ${theme.space[6]};

      svg {
        width: ${theme.space[6]};
      }
    `}
  }
`;

export const Footer = styled('div')`
  display: flex;
  gap: ${theme.space[2]};
  justify-content: flex-end;

  > button {
    display: flex;
    align-items: center;
  }

  ${utils.media.max('m')`
    > button {
      width: 100%;
    }
  `}
`;
